// src/pages/driverReports/carSheets/CarExpenses/saveSheet.js

import { doc, setDoc, getDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../../../firebase/firebase";

/**
 * Save ONLY manual income + expenses + summaries back to Firestore.
 */
export async function saveSheetToFirestore(month, sheetId, baseSheet, summary) {
  const ref = doc(db, "carSheets", month, "sheets", sheetId);

  const sheetToSave = {
  ...baseSheet,
  incomeRows: summary.incomeRows,
  expensesRows: summary.expenseRows,

  totalIncome: summary.totalIncome,
  totalExpenses: summary.totalExpenses,
  balance: summary.balance,
  balancePayable: summary.balancePayable,
  cashReceivedPaid: summary.cashReceivedPaid,
  posTotal: summary.posTotal,

  updatedAt: serverTimestamp(),
};

  await setDoc(ref, sheetToSave, { merge: true });

  const freshSnap = await getDoc(ref);
  return freshSnap.data();
}
